// src/pages/Services.jsx
import React from 'react';
import innerBanner from '../Images/inner-banner-image.jpg';
import Footer from '../Components/Footer';
import { Link } from 'react-router-dom';
import { Nav } from 'react-bootstrap';
import cotton from '../Images/cotton-image.jpg'
import polysterBlend from '../Images/cotton-polyester-blended-fabric.png'
import viscosModal from '../Images/modal-image.jpg'
import viscosBlend from '../Images/viscose-blend-fabric.png'
import modalBlend from '../Images/modal-blend-image.jpg'
import linenImage from '../Images/linen-image.jpg'
import serviceImage from '../Images/32.png'

const Services = () => {
  return (
    <div>
    <div className="inner-banner-section">
      <img src={innerBanner} alt="inner-banner" />
      <div className="inner-banner-heading">
        <span>Services</span>
      </div>
    </div>
    {/* ------------------------------------------- */}



      {/* ------------------------------------------ */}

      <div className="service-page-section-1">
        <div className="container">
          <div className="service-page-section-1-cont">
            <h1>What We Do</h1>
            <p>
            We undertake job work yarn dyeing and bleaching on the following substrates
            </p>
            <div className="service-page-card-section-1">
            <div class="grid">
                <figure class="effect-sadie" data-aos="fade-up" data-aos-duration="1000">
                  <img src={cotton} alt="cotton" />
                  <figcaption>
                    <h2><span>Cotton</span></h2>
                    <p>Pure Quality, Perfectly Colored </p>
                    <a href="#">View more</a>
                  </figcaption>
                </figure>
                <figure class="effect-sadie" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="100">
                  <img src={polysterBlend} alt="polyster Blend" />
                  <figcaption>
                    <h2><span>Cotton & <br /> Polyester blend</span></h2>
                    <p>The Fabric of Excellence <br />in Color and Clean </p>
                    <a href="#">View more</a>
                  </figcaption>
                </figure>
                <figure class="effect-sadie" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="200">
                  <img src={viscosModal} alt="viscos-modal" />
                  <figcaption>
                    <h2> <span>Viscose / Modal /<br /> Tancel</span></h2>
                    <p>Where Purity Meets Perfect Dyeing </p>
                    <a href="#">View more</a>
                  </figcaption>
                </figure>
                <figure class="effect-sadie" data-aos="fade-up" data-aos-duration="1000">
                  <img src={viscosBlend} alt="viscos blend" />
                  <figcaption>
                    <h2><span>Poly / <br />Viscose blend</span></h2>
                    <p>The Natural Choice for Flawless Colors </p>
                    <a href="#">View more</a>
                  </figcaption>
                </figure>
                <figure class="effect-sadie" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="100">
                  <img src={modalBlend} alt="modal-blend-image" />
                  <figcaption>
                    <h2><span>Poly /<br /> Modal blend</span></h2>
                    <p>Bright, Beautiful, and Always Pure</p>
                    <a href="#">View more</a>
                  </figcaption>
                </figure>
                <figure class="effect-sadie" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="200">
                  <img src={linenImage} alt="linen image" />
                  <figcaption>
                    <h2><span>Linen</span></h2>
                    <p>Color with Integrity,<br />Quality without Compromise</p>
                    <a href="#">View more</a>
                  </figcaption>
                </figure>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ----------------------------------------- */}

      {/* <div className="service-page-section-2">
        <div className="container">
          <div className="service-page-section-2-cont">
            <h2>Our Services</h2>
            <div className="service-card-section-2">
              <div className="service-card-2">
                <h4>Lab dips are provided for colour approval within 3-4 days.</h4>
              </div>
              <div className="service-card-2">
                <h4>Sample lot dyeing for 15 Kgs and 25 Kgs is available. Delivery schedule 7-10 days</h4>
              </div>
              <div className="service-card-2">
                <h4>At present , single large batch available is 450 Kgs.</h4>
              </div>
              <div className="service-card-2">
                <h4>After expansion it will be 1200 Kgs and 800 Kgs.</h4>
              </div>
              <div className="service-card-2">
                <h4>All lots are dried using RF dryer only ensuring uniform quality without colour migration.</h4>
              </div>
              <div className="service-card-2">
                <h4>Factory functions 28 days in a month without interruption</h4>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      {/* ----------------------------------------- */}

      <div className="service-page-section-3">
        <div className="container">
          <div className="service-page-section-3-cont">
            <div className="service-page-sec-3-left">
              <h2>We Provide</h2>
              <ul>
                <li><span>Lab dips are provided for colour approval within 3-4 days</span></li>
                <li><span>Sample lot dyeing for15 Kgs and 25Kgs is available. Delivery schedule 7-10 days</span></li>
                <li><span>At present , single large batch available is 450Kgs</span></li>
                <li><span>After expansion it will be 1200 Kgs and 800 Kgs</span></li>
                <li><span>All lots are dried using RF dryer only ensuring uniform quality without colour migration</span></li>
                <li><span>Factory functions 28 days in a month without interruption</span></li>
              </ul>
            </div>
            <div className="service-page-sec-3-right">
              <img src={serviceImage} alt="Service-image" />
            </div>
          </div>
        </div>
      </div>

    {/* ------------------------------------------- */}
    <Footer/>
  </div>
  );
}

export default Services;
